import { ChartPieIcon } from '@heroicons/react/24/solid';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Dataviz from '../../../components/DataViz';
import { PreviewSaraPresentation, SaraPresentation } from '../../../components/SaraPresentation';
import Spinner from '../../../components/Spinner';
import Tabs from '../../../components/Tabs';
import WebsiteTab from '../../../components/WebsiteTab';
import { VISIBILITY_COMPARAISON_CONCURRENT_LINK, VISIBILITY_COMPARAISON_MARKET_LINK } from '../../../constants';
import { fetchConcurrent } from '../../../features/concurrents/concurrentsSlice';
import { getSubscribe } from '../../../features/forfait/forfaitSlice';
import { selectUserInfo } from '../../../features/users/userInfoSlice';
import { fetchWebsites } from '../../../features/websites/websitesSlice';


const subTabs = ['État des lieux', "Comparaison concurrents", "Comparaison profil"];

function Visibility() {
  const dispatch = useDispatch();
  const userInfoContext = useSelector(selectUserInfo)
  const activeWebsite = useSelector(state => state.websites.activeWebsite)
  const subscribe = useSelector(state => state.subscriptions);
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!subscribe.loadingSubscription && !subscribe.product_id) return
    dispatch(getSubscribe({ company_id: userInfoContext?.user?.company_id }))
    dispatch(fetchWebsites({ company_id: userInfoContext?.user?.company_id }))
  }, [])

  useEffect(() => {
    if (activeWebsite) dispatch(fetchConcurrent({ parent_website_id: activeWebsite?.id }))
  }, [activeWebsite])

  if (subscribe.loadingSubscription && !subscribe.product_id)
    return (
      <div className="w-full mx-auto flex justify-center mt-40">
        <Spinner />
      </div>
    );

  if (!localStorage.getItem(userInfoContext?.user?.email) && !subscribe.loadingSubscription && !subscribe.product_id && subscribe.products.length > 0) return <Redirect to="/account/forfait" />;
  if (!subscribe.loadingSubscription && !subscribe.product_id && subscribe.products.length > 0) return <Redirect to="/account" />;

  return (
    <div className="space-y-8 relative pb-4">
      <PreviewSaraPresentation title='Présentation SARA VISIBILITÉ' open={open} setOpen={setOpen} />
      <div className="max-w-md mx-auto mt-10">
        <WebsiteTab />
      </div>
      <Tabs tabs={subTabs} panels={[<Dataviz src={VISIBILITY_COMPARAISON_MARKET_LINK} activeWebsite={activeWebsite} />, <Dataviz src={VISIBILITY_COMPARAISON_CONCURRENT_LINK} activeWebsite={activeWebsite} />, null]} />
      <SaraPresentation reOpen={open} title='Présentation SARA VISIBILITÉ'>
        Vous retrouverez dans cette rubrique le suivi de vos performances digitales sur la thématique de visibilité. <br /><br />
        Vous pourrez vous comparer au marché et également à vos concurrents. <br />
        La comparaison se fait par le biais d'une notation sur 10, il est donc facile de connaitre vos points forts et vos axes d'amélioration. <br /> <br />
        Dans cette rubrique, je vous porpose de faire une audit de votre situation digitale pour vous permettre de mettre en place des actions pour améliorer votre visibilité. <br /> <br />
        En effet, il est important d'avoir déjà un socle optimisé afin de mettre en place des actions de communication qui pourraient ne pas fonctionner car vos actions de démarrage ne sont pas optimales. <br /> <br />
        <ol className="list-decimal ml-3">
          <li>Votre site est-il suffisamment optimisé techniquement, vos pages sur Google my Business ou sur vos réseaux sociaux sont-elles complètes ?</li>
          <li>Vos fréquences d'actions sont-elles suffisantes pour impacter mon activité ?</li>
          <li>Quels sont les résultats de mes actions ?</li>
        </ol>
        <br />
        Je suis là pour vous aider à la compréhension de vos résultats mais si vous souhaitez un accompagnement plus poussé, pensez à contacter nos experts, ils seront à votre écoute. <br />
      </SaraPresentation>
    </div>
  );
}

const MarketComparison = ({ activeWebsite }) => {
  return <div className="max-w-4xl mx-auto bg-white rounded-3xl flex flex-col justify-center items-center p-20">
    <h2 className="text-general-blue text-xl text-center font-medium">DATA VIZ {activeWebsite?.title} </h2>
    <ChartPieIcon className="h-96 text-general-teal" />
  </div>
}

export default Visibility;